import { FC } from 'react';
import styles from './styles.module.scss';

export const Image: FC<{ src: string; size?: string }> = ({ src, size }) => {
	return (
		<img
			style={size ? { height: size } : undefined}
			className={styles.image}
			src={src}
		/>
	);
};
